import { render, staticRenderFns } from "./SocketIn.vue?vue&type=template&id=12e3a558&scoped=true&"
import script from "./SocketIn.vue?vue&type=script&lang=js&"
export * from "./SocketIn.vue?vue&type=script&lang=js&"
import style0 from "./SocketIn.vue?vue&type=style&index=0&id=12e3a558&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12e3a558",
  null
  
)

export default component.exports